import { render, staticRenderFns } from "./TradeHistory.vue?vue&type=template&id=66d94508&scoped=true&"
import script from "./TradeHistory.vue?vue&type=script&lang=js&"
export * from "./TradeHistory.vue?vue&type=script&lang=js&"
import style0 from "./TradeHistory.vue?vue&type=style&index=0&id=66d94508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d94508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VContainer,VIcon,VSheet,VSpacer,VToolbar,VToolbarTitle})
